export const ENDPOINTS_SUBJECTS = {
  GET_ALL: "/api/subjects",
  GET_ALL_ACTIF: "/api/subjects/admin",
  GET_BY_ID: (subjectId: number) => `/api/subjects/${subjectId}`,
  GET_BY_IDCOURSE: (courseId: number) => `/api/subjects/course/${courseId}`,
  POST_SUBJECT: "/api/subjects",
  PUT_SUBJECT: (subjectId: number) => `/api/subjects/${subjectId}`,
  DELETE_SUBJECT: (subjectId: number) => `/api/subjects/${subjectId}`,
  UPLOAD_IMAGE: (subjectId: number) => `/api/subjects/${subjectId}/upload-image`,
  GET_SUBJECTS_AND_PROGRESS: `/api/subjects/progress`,
};

export const ENDPOINTS_COURSES = {
  GET_ALL: "/api/courses",
  GET_ALL_ADMIN: "/api/courses/admin",
  GET_ALL_AND_PROGRESS: "/api/courses/progress",
  GET_DETAILS_BY_ID: (courseId: number) => `/api/courses/${courseId}/details`,
  GET_DETAILS_BY_IDLESSON: (lessonId: number) =>
    `/api/courses/lesson/${lessonId}/details`,
  POST_COURSE: `/api/courses`,
  PUT_COURSE: (courseId: number) => `/api/courses/${courseId}`,
  DELETE_COURSE: (courseId: number) => `/api/courses/${courseId}`,
  UPLOAD_IMAGE: (courseId: number) => `/api/courses/${courseId}/upload-image`,
  GET_COURSES_BY_SUBJECT_ID: (subjectId: number) =>
    `/api/courses/subject/${subjectId}/courses`,
  GET_COURSES_BY_SUBJECT_ID_ADMIN: (subjectId: number) =>
    `/api/courses/subject/${subjectId}/courses/admin`,
  GET_COURSES_BY_SUBJECT_ID_AND_PROGRESS: (subjectId: number) =>
    `/api/courses/subject/${subjectId}/progress`,
};

export const ENDPOINTS_CHAPTERS = {
  GET_ALL: "/api/chapters",
  GET_BY_ID: (epicId: number) => `/api/chapters/${epicId}`,
  POST_CHAPTER: "/api/chapters",
  PUT_CHAPTER: (epicId: number) => `/api/chapters/${epicId}`,
  DELETE_CHAPTER: (epicId: number) => `/api/chapters/${epicId}`,
  GET_CHAPTERS_BY_COURSE_ID: (id: number) => `/api/courses/${id}/chapters`,
};

export const ENDPOINTS_EPICS = {
  GET_ALL: "/api/epics",
  GET_BY_ID: (epicId: number) => `/api/epics/${epicId}`,
  POST_EPIC: "/api/epics",
  PUT_EPIC: (epicId: number) => `/api/epics/${epicId}`,
  DELETE_EPIC: (epicId: number) => `/api/epics/${epicId}`,
  GET_EPICS_BY_CHAPTER_ID: (chapterId: number) =>
    `/api/chapters/${chapterId}/epics`,
};

export const ENDPOINTS_LESSONS = {
  GET_ALL: "/api/lessons",
  GET_BY_ID: (lessonId: number) => `/api/lessons/${lessonId}`,
  GET_DETAILS_BY_ID: (lessonId: number) => `/api/lessons/${lessonId}/details`,
  POST_SAVE_LESSON_DETAILS: `/api/lessons/details`,
  POST_LESSON: "/api/lessons",
  PUT_LESSON: (lessonId: number) => `/api/lessons/${lessonId}`,
  POST_DUPLICATE: (lessonId: number) => `/api/lessons/${lessonId}/duplicate`,
  DELETE_LESSON: (lessonId: number) => `/api/lessons/${lessonId}`,
  GET_LESSONS_BY_EPIC_ID: (epicId: number) => `/api/epics/${epicId}/lessons`,
};